// extracted by mini-css-extract-plugin
module.exports = {"main":"PageSizeSelector_main__180FX","select":"PageSizeSelector_select__JBQ-d"};